//
//
//
//

import { BuyingGuideCard, BuyingGuideList } from './Ads/BuyingGuide'
import { HelpCard, HelpList } from './Ads/Help'
import { PaymentCard, PaymentList } from './Ads/Payment'

export const ADS = {
  PAYMENT: 'payment',
  FAQ: 'faq',
  BUYING_GUIDE: 'buyingGuide',
}
export const AD_DISPLAYS = {
  LIST: 'list',
  CARD: 'card',
}

export default {
  props: {
    name: {
      type: String,
      required: true,
      validator: (value) => Object.values(ADS).includes(value),
    },
    display: {
      type: String,
      default: AD_DISPLAYS.CARD,
      validator: (value) => Object.values(AD_DISPLAYS).includes(value),
    },
  },
  computed: {
    paymentComponent() {
      switch (this.display) {
        case AD_DISPLAYS.LIST:
          return PaymentList
        case AD_DISPLAYS.CARD:
          return PaymentCard
        default:
          return null
      }
    },
    faqComponent() {
      switch (this.display) {
        case AD_DISPLAYS.LIST:
          return HelpList
        case AD_DISPLAYS.CARD:
          return HelpCard
        default:
          return null
      }
    },
    buyingGuideComponent() {
      switch (this.display) {
        case AD_DISPLAYS.LIST:
          return BuyingGuideList
        case AD_DISPLAYS.CARD:
          return BuyingGuideCard
        default:
          return null
      }
    },
    adComponent() {
      switch (this.name) {
        case ADS.PAYMENT:
          return this.paymentComponent
        case ADS.FAQ:
          return this.faqComponent
        case ADS.BUYING_GUIDE:
          return this.buyingGuideComponent
        default:
          return null
      }
    },
  },
}
